<template>
  <div>
      <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Signing In..</p>
            </div>
        </transition>

        <!-- Login modal -->
        <b-modal no-fade size="l" id="modal-login" title="Sign In" ok-title="Sign In" @ok="login()" @cancel="cancelLogin()">
            Login to accept this order 
            <b-input-group prepend="Email" class="mt-3">
                <b-form-input v-model="email"></b-form-input>
            </b-input-group>
            <b-input-group prepend="Password" class="mt-3">
                <b-form-input type="password"  v-model="password"></b-form-input>
            </b-input-group>
            <!-- Forgot password -->
            <div style="color:grey; margin-top:10px">
                <a @click="resetPassword()">Forgot Password?</a>
            </div>
        </b-modal>

        <!-- Accept order modal -->
        <b-modal no-fade size="l" id="modal-acceptorder" title="Accept Order" ok-title="Yes, Accept Order" cancel-title="Not yet" @ok="acceptOrder()" @cancel="cancelAcceptOrder()">
            <h5>Accept order for {{order.beerName}} from {{order.pub}}?</h5>
            <!-- Delivery Date -->
            <br>
            Delivery Date
            <b-form-datepicker :id="order.suborderid" value-as-date  v-model="order.deliveryTime" class="mb-2"></b-form-datepicker>

            <div v-if="order.desiredDate" style='color:green; width:150px'>
                <small v-if='status==0'>Buyer requested {{order.deliveryTime}} delivery date</small>
            </div>
        </b-modal>

        <!-- Invalid order modal -->
        <b-modal ok-only no-fade size="l" id="modal-invalidorder" title="Invalid Order" @ok="goToHome()">
            This is an invalid order
        </b-modal>

        <!-- Invalid delivery date -->
        <b-modal ok-only no-fade size="l" id="modal-dateerror" title="Invalid Delivery Date" @ok="showAcceptOrder()">
            Must set a delivery date first
        </b-modal>

        <!-- Order already accepted modal -->
        <b-modal ok-only no-fade size="l" id="modal-alreadyaccepted" title="Order Already Accepted" @ok="goToHome()">
            This order has already been accepted
        </b-modal>
        
        <b-container>
            <b-row>
                <b-col>
                    <h4>Accept Order</h4>
                </b-col>
            </b-row>

            <!-- Must log in message -->
            <b-row v-if="!isLoggedIn" style="margin-top:20px">
                <b-col>
                    <h4>You must be logged in to accept this order</h4>
                </b-col>
            </b-row>

            <!-- Invalid login -->
            <b-row v-if="errorMsg" style="margin-top:20px; color:red">
                <b-col>
                    <h4>{{errorMsg}}</h4>
                    <br>
                    <b-button variant="info" v-b-modal.modal-login>Try Again</b-button>
                </b-col>
            </b-row>


        </b-container>
      
  </div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import {sendnotification} from './Myfunctions'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {
            isLoggedIn:false,
            performingRequest:false,
            order:{},
            email:'',
            password:'',
            errorMsg:'',
            deliveryTime:'',
        }
    },

    methods:{
        //Login user
        login(){
            this.performingRequest = true
            console.log("Signing in ")
            this.errorMsg = ""
            fb.auth.signInWithEmailAndPassword(this.email, this.password).then(user => {
                this.$store.commit('setCurrentUser', user.user)
                
                this.getOrder()
                    
            }).catch(err => {
                this.isLoggedIn=false
                console.log(err)
                this.performingRequest = false
                this.errorMsg = err.message
            })
        },

        //Login cancel pressed
        cancelLogin(){
            console.log("Login cancelled")
            this.errorMsg="You must be logged on to accept this order"
            this.performingRequest = false
        },

        //Get the order
        getOrder(){
            var fbref = fb.ordersCollection
            console.log("Getting order")
            fbref.where('suborderid', '==', this.suborderid).get().then(docs => {
                docs.forEach(doc => {
                    let theOrderData = doc.data()
                    console.log("Order = ")
                    console.log(theOrderData)
                    this.order = theOrderData
                    this.isLoggedIn=true
                    this.performingRequest = false

                })
            }).then(res => {
                    if(this.order.brewerid){
                        this.performingRequest = false
                        this.showAcceptOrder()
                    }
                    else{
                        this.$bvModal.show("modal-invalidorder")
                        this.performingRequest = false
                    }
                
                })
            .catch(err => {
                console.log(err)
            })

        },
        //Show accept order
        showAcceptOrder(){
            //Show if brewer ID = user id
            this.performingRequest = false
            var isValidUser = false
            if(this.currentUser.uid == this.order.brewerid) isValidUser = true
            //Check for reps
            //Get all reps for brewerid

            var docRef = fb.usersCollection.doc(this.order.brewerid);
            docRef.get().then((doc) => {
                if (doc.exists) {
                    console.log("Document data:", doc.data());
                    const brewerData = doc.data()
                    if(brewerData.reps&&brewerData.reps.length>0){
                        const reps = brewerData.reps
                        //Check if user is part of reps
                        const existingRepindex = reps.findIndex(item => item.uid === this.currentUser.uid);
                        if(existingRepindex>=0) isValidUser=true
                    }

                    //Show confirmation dialogs
                    if(isValidUser&&this.order.status==0){
                        this.performingRequest = false
                        this.$bvModal.show("modal-acceptorder")
                    }
                    else if (isValidUser&&this.order.status!=0){
                        this.performingRequest = false
                        this.$bvModal.show("modal-alreadyaccepted")
                    }
                    else{
                        this.performingRequest = false
                        this.$bvModal.show("modal-invalidorder")
                    }
                    
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document in accept order brewer profile!");
                }
            }).catch((error) => {
                this.performingRequest = false
                console.log("Error getting document brewer profile in acceptorder:", error);
            });
            

        },

        //Accept Order
        acceptOrder(){
            this.performingRequest = false
            //Check of delivery date selected
            if(!this.order.deliveryTime) {
                this.$bvModal.show("modal-dateerror")
                return
            }
            var nowDate = new Date()
            var lastUpdated = nowDate.getTime()

            fb.ordersCollection.where('suborderid', '==', this.order.suborderid).get().then(docs => {
                docs.forEach(doc => {
                    fb.ordersCollection.doc(doc.id).update({
                        status: 1,
                        acceptedOn: nowDate,
                        acceptedbyuid:this.currentUser.uid,
                        acceptedbyemail:this.currentUser.email,
                        deliveryDate:this.order.deliveryTime,
                        lastUpdated:lastUpdated,
                    })

                    // Add to news feed
                    var feedString
                    var feedObject = {}
                    feedObject.brewerId = this.currentUser.uid
                    feedObject.pubId = this.order.pubid
                    feedString = this.userProfile.company + ' Accepted order for: ' + this.order.beerName + ' from ' + this.order.pub
                    feedObject.feedString = feedString
                    this.$store.dispatch('addToNewsFeed',feedObject)

                    this.$bvToast.toast('Order Accepted', {
                        title: 'Order Accepted!',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                    })


                    //Fire notification
                    try {
                        sendnotification(this.order.pubId, feedString)
                        }
                    catch(err) {
                        console.log("Notification send error")
                        }

                    this.goToHome()

                    })
                })
                .catch(err => {
                    console.log(err)
                    this.goToHome()
                })


            

        },
        //Cancel accept order
        cancelAcceptOrder(){
            this.performingRequest = false
            console.log("Canceling accept")
            this.goToHome()
        },

        //Reset password
        resetPassword(){
            this.performingRequest = false
            this.$router.push({path:'/forgotpassword'})
        },

        //Go to home
        goToHome(){
            this.performingRequest = false
            this.$router.push({path:'/login'})

        },
    },

    mounted(){
        //Get order id
            this.suborderid = this.$route.params.orderid 
            if (this.suborderid ){
                console.log("Order id = " + this.suborderid)
                //Check if user is logged in. If not, show login window
                if(this.currentUser){
                    this.isLoggedIn=true
                    this.getOrder()
                }
                else{
                    this.$bvModal.show("modal-login")
                }
            }
            //No order ID, show home page
            else{
                this.$bvModal.show("modal-invalidorder")
            }
    },
}
</script>

